import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ratingImages = [
  `${process.env.PUBLIC_URL}/images/rate1.jpg`,
  `${process.env.PUBLIC_URL}/images/rate2.jpg`,
  `${process.env.PUBLIC_URL}/images/rate3.jpg`,
  `${process.env.PUBLIC_URL}/images/rate4.jpg`,
  `${process.env.PUBLIC_URL}/images/rate5.jpg`,
];

const MobileRating = () => {
  const [selectedRating, setSelectedRating] = useState(0);
  const [comment, setComment] = useState("");
  const [viewKey, setViewKey] = useState(null);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const [verificationMessage, setVerificationMessage] =
    useState("Verifying...");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const key = params.get("view_key");
    if (!key) {
      setVerifying(false);
      return;
    }
    setViewKey(key);
    handleVerifySubmission(key);
  }, []);

  const handleVerifySubmission = async (view_key) => {
    if (!view_key) return;
    setVerifying(true);
    try {
      const response = await fetch(
        "https://skindevreplica.api.tatamotors/api/pifir/verify_link/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ view_key }),
        }
      );
      const data = await response.json();
      if (!data.status) {
        setFeedbackSubmitted(true);
      }
      setVerifying(false);
    } catch (error) {
      setVerificationMessage("Link not valid");
    }
  };

  const handleRatingClick = async (index) => {
    const ratingValue = index + 1;
    setSelectedRating(ratingValue);
    setShowCommentSection(ratingValue >= 4);

    if (ratingValue <= 3) {
      await submitFeedback(ratingValue, "");
    }
  };

  const submitFeedback = async (rating, commentText) => {
    if (!viewKey) {
      alert("View key is missing.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://skindevreplica.api.tatamotors/api/pifir/fdbk/?view_key=${viewKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            feedback: rating.toString(),
            comment: commentText,
          }),
        }
      );
      const data = await response.json();
      if (data.feedback_collection === 1 || data.feedback_collection === 0) {
        setFeedbackSubmitted(true);
        alert("Thank you for your feedback!");
        setTimeout(() => window.close(), 1000);
      } else {
        alert(data.msg || "Submission failed. Please try again.");
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (selectedRating >= 4) {
      submitFeedback(selectedRating, comment);
    }
  };

  if (verifying) {
    return <h3>{verificationMessage}</h3>;
  }
  if (feedbackSubmitted) {
    return (
      <h3
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "100px",
        }}
      >
        Thank you for your feedback!
      </h3>
    );
  }

  return (
    <div
      className="container"
      style={{
        backgroundColor: "white",
        minHeight: "100vh",
        zIndex: "1000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <h3>How was your experience?</h3> */}
      <div className="rating-text">How was your experience?</div>

      <div className="rating-container-mobile">
        {ratingImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Rating ${index + 1}`}
            onClick={() => handleRatingClick(index)}
            style={{
              width: "50px",
              height: "50px",
              cursor: "pointer",
              opacity: selectedRating === index + 1 ? 1 : 0.5,
            }}
          />
        ))}
      </div>

      {showCommentSection && (
        <div id="commentSection">
          <h3>Please Enter Your Comment</h3>
          <input
            type="text"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter your comment"
            style={{
              padding: "8px",
              width: "300px",
              marginRight: "10px",
              marginTop: "20px",
            }}
          />

          <button
            onClick={handleSubmit}
            style={{
              padding: "8px 15px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              cursor: "pointer",
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
            disabled={loading}
          >
            {loading ? (
              <span
                className="loader"
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid white",
                  borderTop: "2px solid transparent",
                  borderRadius: "50%",
                  display: "inline-block",
                  animation: "spin 1s linear infinite",
                  marginRight: "8px",
                }}
              ></span>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      )}
      <style>
        {`
          .container {
            background-color: white;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            
          }
          .rating-text {
            font-size: 18px;
            
          }
          .rating-container-mobile {
           
            position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  text-align: center;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  
            
          }
          .rating-image {
            cursor: pointer;
            transition: transform 0.2s;
          }
          .rating-image:hover {
            transform: scale(1.1);
          }
.rating-image.active {
            border: 2px solid blue;
            border-radius: 50%;
          }
          .comment-input {
            padding: 8px;
            width: 250px;
            margin: 10px 0;
            border: 1px solid #ccc;
            border-radius: 5px;
          }
          .submit-button {
            padding: 8px 15px;
            background-color: #007bff;
            color: white;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
          }
          .submit-button:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }
          .loader {
            width: 16px;
            height: 16px;
            border: 2px solid white;
            border-top: 2px solid transparent;
            border-radius: 50%;
            display: inline-block;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .feedback-submitted {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            text-align: center;
            padding: 20px;
            border: 2px solid black;
            width: 300px;
            border-radius: 10px;
            background-color: #f9f9f9;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }
        `}
      </style>
    </div>
  );
};

export default MobileRating;
